import React from 'react'

interface Props {
  date?: Date
  timestamp?: number
  withTime?: boolean
}

export const DateDisplay: React.FC<Props> = (props: Props) => {
  // const date = props.date || new Date(props.timestamp!);
  var formattedDate = formatDate(
    props.date,
    props.timestamp,
    false,
    props.withTime
  )

  return <span>{formattedDate}</span>
}

export function dateTimeFormatTimestamp(
  timestamp: number,
  options: Intl.DateTimeFormatOptions
) {
  const date = new Date(timestamp)
  return date.toLocaleString('default', options)
}

export function formatTimestamp(
  timestamp: number,
  humanReadable: boolean = false,
  withTime: boolean = false,
  withSeconds: boolean = false
) {
  return formatDate(undefined, timestamp, humanReadable, withTime, withSeconds)
}

export function formatDate(
  date?: Date,
  timestamp?: number,
  humanReadable: boolean = false,
  withTime: boolean = false,
  withSeconds: boolean = false
) {
  var now = new Date()

  var dateToFormat = date || (timestamp && new Date(timestamp)) || now

  const locale = 'en-GB'

  var yesterday = new Date()
  yesterday.setDate(now.getDate() - 1)

  var formattedDate = humanReadable
    ? isSameDate(dateToFormat, now)
      ? 'Today'
      : isSameDate(dateToFormat, yesterday)
      ? 'Yesterday'
      : dateToFormat.toLocaleDateString(locale)
    : dateToFormat.toLocaleDateString(locale)

  var options: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    second: withSeconds ? 'numeric' : undefined
  }
  var formattedTime = dateToFormat.toLocaleTimeString(locale, options)

  return withTime
    ? `${formattedDate} ${humanReadable && 'at '}${formattedTime}`
    : formattedDate
}

function isSameDate(dateToCheck: Date, dateToCompare: Date) {
  return (
    dateToCheck.getDate() === dateToCompare.getDate() &&
    dateToCheck.getMonth() === dateToCompare.getMonth() &&
    dateToCheck.getFullYear() === dateToCompare.getFullYear()
  )
}
